import { useCallback, useEffect, useRef, useState } from 'react';
import { createDraftSaver, editableDraft } from '../_lib/draftSaver';
export default function useDraftAutosave({ id, campaign, update }) {
 const [draft, setDraft] = useState(null); const [status, setStatus] = useState({ dirty: false, saving: false, error: null });
 const saver = useRef(null); const latest = useRef(null); const updateRef = useRef(update); updateRef.current = update;
 useEffect(() => {
  const queue = createDraftSaver({ save: (body) => updateRef.current({ id, ...body }).unwrap(), onStatus: setStatus });
  saver.current = queue;
  return () => { queue.dispose(); if (saver.current === queue) saver.current = null; };
 }, [id]);
 useEffect(() => {
  if (!campaign || !saver.current) return;
  if (!latest.current) { latest.current = editableDraft(campaign); setDraft(latest.current); }
  saver.current.seed(latest.current);
 }, [campaign, id]);
 const patch = useCallback((changes) => {
  if (!latest.current || !saver.current) return;
  const next = { ...latest.current, ...changes }; latest.current = next; setDraft(next); saver.current.change(next);
 }, []);
 const flush = useCallback(() => saver.current ? saver.current.flush() : Promise.reject(new Error('The draft is not ready.')), []);
 useEffect(() => {
  if (!status.dirty) return undefined;
  const warn = (event) => { event.preventDefault(); event.returnValue = ''; };
  window.addEventListener('beforeunload', warn);
  return () => window.removeEventListener('beforeunload', warn);
 }, [status.dirty]);
 return { draft, patch, flush, ...status };
}
